import {
  MSP_DOCUMENT_CATEGORY_VALUES,
  MSP_DOCUMENT_DIFFICULTY_VALUES,
  type MspDocumentCategory,
  type MspDocumentDifficulty,
} from "@/lib/constants/msp-doc-enums";

export interface SelectOption<T extends string = string> {
  value: T;
  label: string;
}

const CATEGORY_LABELS: Record<MspDocumentCategory, string> = {
  procedures: "Procedures",
  technical: "Technical Guides",
  "best-practices": "Best Practices",
  "client-specific": "Customer-specific",
  troubleshooting: "Troubleshooting",
  templates: "Templates",
};

const DIFFICULTY_LABELS: Record<MspDocumentDifficulty, string> = {
  beginner: "Beginner",
  intermediate: "Intermediate",
  advanced: "Advanced",
};

/** UI select options — values from `MSP_DOCUMENT_CATEGORY_VALUES`. */
export const MSP_DOCUMENT_CATEGORIES: SelectOption<MspDocumentCategory>[] =
  MSP_DOCUMENT_CATEGORY_VALUES.map((value) => ({
    value,
    label: CATEGORY_LABELS[value],
  }));

/** UI select options — values from `MSP_DOCUMENT_DIFFICULTY_VALUES`. */
export const MSP_DOCUMENT_DIFFICULTIES: SelectOption<MspDocumentDifficulty>[] =
  MSP_DOCUMENT_DIFFICULTY_VALUES.map((value) => ({
    value,
    label: DIFFICULTY_LABELS[value],
  }));
